import React from "react";

export function OfferReceivedBadge() {
  return <span className="text-success">(Offer received)</span>;
}
